
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {MobileAppLinksRepository} from '@/profile-creation-wizard/components/for-creation/MobileAppLinksRepository';
    import mutations from '@/profile-creation-wizard/components/for-creation/store/mutations';

    @Options({})
    export default class App extends Vue {
        @Inject({from: DI.mobileAppLinksRepository})
        mobileAppLinksRepository!: MobileAppLinksRepository;

        async created(): Promise<void> {
            const [links] = await this.mobileAppLinksRepository.getLinks();

            if (links) {
                this.$store.commit(mutations.setupQrcode, `${links.qrcodeUrl}&w=113&orig=signup`);
            }
        }
    }
